
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export default class UiVideoControlComponent extends Vue {
  @Prop({ default: false })
  src!: string | Blob;
  @Prop()
  name!: string;
  isPlay: boolean = false;
  duration: number = 0;
  currentTime: number = 0;
  temp: number = 0;
  wrapperStyle: Object  = { };
  @Watch('src')
  onSrcChanged() {
    this.stopWatch();
    this.isPlay = false;
    this.currentTime = 0;
    this.duration = 0;
  }
  get safeDuration(): number {
    if (!Number.isFinite(this.duration) || this.duration <= 0) {
      return 0;
    }
    return this.duration;
  }
  get safeCurrentTime(): number {
    if (!Number.isFinite(this.currentTime) || this.currentTime <= 0) {
      return 0;
    }
    if (!this.safeDuration) {
      return this.currentTime;
    }
    return Math.min(this.currentTime, this.safeDuration);
  }
  get percentCompelete(): number {
    if (!this.safeCurrentTime || !this.safeDuration) {
      return 0;
    }
    return Math.min((this.safeCurrentTime / this.safeDuration) * 100, 100);
  }
  setCurrentTime(value : number) {
    const normalizedValue = Math.min(Math.max(value, 0), this.safeDuration || value);
    this.videoEl.currentTime = normalizedValue;
    this.currentTime = normalizedValue;
  }
  private formatTime(value: number, roundMode: 'floor' | 'ceil' = 'floor'): string {
    if (!Number.isFinite(value) || value <= 0) {
      return '00:00';
    }
    const totalSeconds = roundMode === 'ceil' ? Math.ceil(value) : Math.floor(value);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    const displayMinutes = minutes < 10 ? `0${minutes}` : minutes;
    const displaySeconds = seconds < 10 ? `0${seconds}` : seconds;
    return `${displayMinutes}:${displaySeconds}`;
  }
  get timeDisplay(): string {
    return `${this.formatTime(this.safeCurrentTime)} / ${this.formatTime(this.safeDuration, 'ceil')}`;
  }
  timeout: NodeJS.Timeout;
  get videoEl(): HTMLVideoElement {
    return this.$refs.videoEl as HTMLVideoElement;
  }
  onChangeTrack(e: Event) {
    var trg = e.target as HTMLInputElement;
    this.setCurrentTime(Number(trg.value));
  }
  playStop() {
    this.isPlay = !this.isPlay;
    if (this.isPlay) {
      const playPromise = this.videoEl.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(() => {
          this.isPlay = false;
          this.stopWatch();
        });
      }
      this.startWatch();
    } else {
      this.videoEl.pause();
      this.stopWatch();
    }
  }
  beforeDestroy() {
    this.stopWatch();
  }
  stopWatch() {
    this.timeout && clearInterval(this.timeout);
    this.timeout = null;
  }
  startWatch() {
    if(this.timeout) {
      return;
    }
    this.timeout = setInterval(this.refreshTime, 1000);
  }
  refreshTime() {
    this.currentTime = this.videoEl.currentTime;
  }
  loadedmetadata(e: Event) {
    const duration = (e.target as HTMLMediaElement).duration;
    this.duration = Number.isFinite(duration) && duration > 0 ? duration : 0;
    
    this.wrapperStyle = {
      maxWidth: `${this.videoEl.clientWidth}px`,
      maxHeight: `${this.videoEl.clientHeight}px`
    };
  }
  onPause(e: any) {
    this.isPlay = false;    
    this.stopWatch();
  }
  onEnd() {
    this.isPlay = false;
    this.currentTime = this.safeDuration;
    this.stopWatch();
  }
  onStart() {
    this.startWatch();
  }
}
